export default "__VITE_ASSET__C_Xr8ODa__"